var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPreScreenCompletedParty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 82,
    viewBox: "0 0 83 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "party 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.11245 75.2145L24.4166 20.5L61.9999 58.0833L7.28545 77.3875C6.98252 77.4923 6.65621 77.5098 6.34382 77.4379C6.03144 77.366 5.74558 77.2077 5.51891 76.981C5.29225 76.7544 5.13393 76.4685 5.06206 76.1561C4.99018 75.8437 5.00764 75.5174 5.11245 75.2145Z",
    stroke: "#86AC44",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.7021 53.6914L19.2006 73.1886",
    stroke: "#86AC44",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M21.4883 28.7969L34.487 67.793",
    stroke: "#86AC44",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M41.5 37.582L49.782 62.428",
    stroke: "#86AC44",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M31.25 13.6667L34.6667 5.125",
    stroke: "#86AC44",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M68.833 51.2487L77.3747 47.832",
    stroke: "#86AC44",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M62 40.9993C63.1217 40.9993 64.2324 40.7784 65.2688 40.3492C66.3051 39.9199 67.2467 39.2907 68.0399 38.4976C68.833 37.7044 69.4622 36.7628 69.8915 35.7264C70.3207 34.6901 70.5417 33.5794 70.5417 32.4577C70.5417 30.1923 71.4416 28.0197 73.0435 26.4178C74.6453 24.8159 76.8179 23.916 79.0833 23.916",
    stroke: "#86AC44",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M41.5 20.4993C41.5 18.234 42.3999 16.0614 44.0018 14.4595C45.6037 12.8576 47.7763 11.9577 50.0417 11.9577C52.3071 11.9577 54.4797 11.0578 56.0815 9.45589C57.6834 7.85401 58.5833 5.68141 58.5833 3.41602",
    stroke: "#86AC44",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M72.25 15.375C75.0805 15.375 77.375 13.0805 77.375 10.25C77.375 7.41954 75.0805 5.125 72.25 5.125C69.4195 5.125 67.125 7.41954 67.125 10.25C67.125 13.0805 69.4195 15.375 72.25 15.375Z",
    stroke: "#86AC44",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M51.75 30.75L62 20.5",
    stroke: "#86AC44",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreScreenCompletedParty);
export default __webpack_public_path__ + "static/media/pre-screen-completed-party.9df40ca25343e195935b4106ae30923a.svg";
export { ForwardRef as ReactComponent };